import Vue from 'vue'
import Vuex from 'vuex'
import vuexCache from 'vuex-cache'
// store modules
import dashboard from './modules/dashboard'
import userProfile from './modules/user-profile'
import userAccount from './modules/user-account'
import userService from './modules/user-service'
import userRole from './modules/user-role'
import userState from './modules/user-state'
import cleanerEvents from './modules/cleaner-events'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    dashboard,
    userProfile,
    userAccount,
    userService,
    userRole,
    userState,
    cleanerEvents
  },
  plugins: [vuexCache({ timeout: 300000 })], // 5 mins
  strict: debug
})
